// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  pre: true,
  qa: false,
  code: "GSLP",
  module: "gscc-portals",
  portalTitle: "UK GSCC Landing Portal",
  basePath: "https://gslp-bff.qa-uk-trackandtrace-dentsutracking.com",
  landingPortal: "https://gslp-fr.qa-uk-trackandtrace-dentsutracking.com",
  dashboardPath: "",
  quicksighhtId: "0977584e-8097-4008-beab-cdf42c94a528",
  portalVersion: "1.0.1"
};
